import React from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";

import {
  EditionButton,
  EditionContainer,
  EditionLayer,
  RightSlideAnimation
} from "../../AdAssistant.styled";
import { EmptyButton } from "../../overview/AdAssistantOverview.styled";
import { EditIcon, XIcon } from "../../../../Components/Icons";
import { SimpleTickIcon } from "../../../../Components/Icons/Tick";

const UseDismissHoverLayer = ({
  isAdPreviewHovered,
  toggleAdSelection,
  toggleAdSelectionEdition,
  isDismissed,
  isUsed,
  width = "inherit",
  height = "inherit"
}) => {
  const { t } = useTranslation();

  const renderUseButton = () => {
    if (isUsed) return null;
    return (
      <EditionButton hoverColor="#8dc572" onClick={() => toggleAdSelection(true)}>
        <SimpleTickIcon color="var(--primary-white)" />
        {t("Use it")}
      </EditionButton>
    );
  };

  const renderDismissButton = () => {
    if (isDismissed) return null;
    return (
      <EditionButton hoverColor="#be6464" onClick={() => toggleAdSelection(false)}>
        <XIcon color="var(--primary-white)" thickness={1.5} />
        {t("Dismiss")}
      </EditionButton>
    );
  };

  return (
    <AnimatePresence>
      {isAdPreviewHovered && (
        <motion.div {...RightSlideAnimation} style={{ width, height, position: "absolute" }}>
          <EditionLayer>
            <EditionContainer>
              {renderUseButton()}
              {renderDismissButton()}
              <div style={{ position: "absolute", top: 10, right: 15 }}>
                <EmptyButton onClick={toggleAdSelectionEdition}>
                  <EditIcon color="white" size={24} strokeWidth={1} />
                </EmptyButton>
              </div>
            </EditionContainer>
          </EditionLayer>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UseDismissHoverLayer;
